import React from "react"; // eslint-disable-line
import PropTypes from "prop-types";
import generate from "shortid";

import { MainPie, InnerPie } from "../..";
import "./PieChart.scss";
import Gradients from "./Gradients";

const PieChart = ({
  failure,
  success,
  avgFailure,
  avgSuccess,
  pieIndex,
  parameter,
  hasTooltip
}) => {
  const gamePercent = ((success / (success + failure)) * 100) || 0;
  const avgPercent = (avgSuccess / (avgSuccess + avgFailure)) * 100 || 0;
  return (
    <div className="pie-chart">
      <div className="pie-chart__pie">
        <Gradients />
        <div className="pie-chart__pie__position-prefixer">
          <MainPie
            gradient={`url(#gradient${pieIndex + 1})`} // eslint-disable-line
            failure={failure}
            success={success}
            uniqueId={generate()}
            percentage={gamePercent}
            index={pieIndex}
          />
        </div>
        {hasTooltip &&
          <div className="pie-chart__pie__position-prefixer">
            <InnerPie
              gradient={`url(#gradientInner${pieIndex + 1})`} // eslint-disable-line
              failure={avgFailure}
              success={avgSuccess}
              hasTooltip={hasTooltip}
              percent={avgPercent}
            />
          </div>}
      </div>
      <div className="pie-chart__details">
        <span>{`${success === null ? 0 : success} / ${(success + failure).toFixed(1)}`}</span>
        <span>{parameter}</span>
      </div>
    </div>
  );
};

PieChart.propTypes = {
  avgFailure: PropTypes.number,
  avgSuccess: PropTypes.number,
  failure: PropTypes.number,
  hasTooltip: PropTypes.bool,
  parameter: PropTypes.string,
  pieIndex: PropTypes.number,
  success: PropTypes.number
};

PieChart.defaultProps = {
  avgFailure: 0,
  avgSuccess: 0,
  failure: 0,
  hasTooltip: true,
  parameter: "",
  pieIndex: 0,
  success: 0
};

export default PieChart;
